const LoadingSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Filter Panel Skeleton */}
      <div className="bg-card border border-border rounded-industrial p-6 animate-pulse">
        <div className="space-y-4">
          <div className="h-6 bg-muted rounded w-1/3"></div>
          <div className="h-10 bg-muted rounded"></div>
          <div className="h-10 bg-muted rounded"></div>
          <div className="h-10 bg-muted rounded"></div>
        </div>
      </div>
      {/* Sort Controls Skeleton */}
      <div className="bg-card border border-border rounded-industrial p-4 animate-pulse">
        <div className="flex justify-between items-center">
          <div className="h-4 bg-muted rounded w-1/4"></div>
          <div className="flex space-x-2">
            <div className="h-8 bg-muted rounded w-24"></div>
            <div className="h-8 bg-muted rounded w-16"></div>
          </div>
        </div>
      </div>
      {/* Equipment Cards Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 9 })?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-industrial overflow-hidden animate-pulse">
            <div className="h-48 bg-muted"></div>
            <div className="p-4 space-y-3">
              <div className="h-6 bg-muted rounded"></div>
              <div className="h-8 bg-muted rounded w-2/3"></div>
              <div className="space-y-2">
                <div className="h-4 bg-muted rounded"></div>
                <div className="h-4 bg-muted rounded"></div>
                <div className="h-4 bg-muted rounded"></div>
              </div>
              <div className="flex justify-between items-center">
                <div className="h-4 bg-muted rounded w-1/3"></div>
                <div className="h-4 bg-muted rounded w-1/4"></div>
              </div>
              <div className="space-y-2">
                <div className="h-8 bg-muted rounded"></div>
                <div className="h-8 bg-muted rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;